export default class SearchAssignmentForm {
  constructor() {
    this.form = document.getElementById('SearchAssignmentForm');
    this.OtherCitiesCheckbox = this.form.querySelector('input[type=checkbox][name=OtherCitiesBool]');
    if (this.OtherCitiesCheckbox) {
      this.OtherCitiesInput = this.form.querySelector('#SearchAssignmentForm_OtherCities_Holder');
    }
    this.ObjectTypeSelect = this.form.querySelector('select[name=ObjectType]');
    this.ObjectTypeHouseType = this.form.querySelector('#SearchAssignmentForm_HouseType_Holder');
    if (this.ObjectTypeHouseType) {
      this.ObjectTypeHouseInputs = this.ObjectTypeHouseType.querySelectorAll('input[type=checkbox]');
    }
    this.ObjectTypeAppartmentType = this.form.querySelector('#SearchAssignmentForm_AppartmentType_Holder');
    if (this.ObjectTypeAppartmentType) {
      this.ObjectTypeAppartmentInputs = this.ObjectTypeAppartmentType.querySelectorAll('input[type=checkbox]');
    }
    this.SurfaceField = this.form.querySelector('#SearchAssignmentForm_Surface_Holder');
    if (this.SurfaceField) {
      this.SurfaceSelect = this.SurfaceField.querySelector('#SearchAssignmentForm_Surface');
    }

    if (!this.form) {
      return;
    }

    this.setOtherCitesInput = this.setOtherCitesInput.bind(this);
    this.setObjectTypeSuggestions = this.setObjectTypeSuggestions.bind(this);

    this.setOtherCitesInput();
    this.setObjectTypeSuggestions();
    this._setDOMReferences();
  }

  _setDOMReferences() {
    if (this.OtherCitiesCheckbox) {
      this.OtherCitiesCheckbox.addEventListener('change', () => this.setOtherCitesInput());
    }
    if (this.ObjectTypeSelect) {
      this.ObjectTypeSelect.addEventListener('change', () => this.setObjectTypeSuggestions());
      console.log('check');
    }
  }

  setOtherCitesInput() {
    if (!this.OtherCitiesInput) {
      return;
    }

    if (this.OtherCitiesCheckbox.checked) {
      this.OtherCitiesInput.classList.remove('hidden');
    } else {
      this.OtherCitiesInput.classList.add('hidden');
    }
  }

  setObjectTypeSuggestions() {
    const val = this.ObjectTypeSelect.value;
    console.log(val);
    if (val === 'WOONHUIS') {
      this.showHouseType();
      this.hideAppartmentType();
    } else if (val === 'APPARTEMENT') {
      this.hideSurfaceField();
      this.showAppartmentType();
      this.hideHouseType();
    } else if (val === 'WOONHUIS_OF_APPARTEMENT') {
      this.showHouseType();
      this.showAppartmentType();
    } else {
      this.hideHouseType();
      this.hideAppartmentType();
    }

    if (val !== 'APPARTEMENT') {
      this.showSurfaceField();
    }
  }

  showHouseType() {
    if (!this.ObjectTypeHouseInputs.length) {
      return;
    }
    this.ObjectTypeHouseType.classList.remove('hidden');
    for (let i = 0; i < this.ObjectTypeHouseInputs.length; i++) {
      const element = this.ObjectTypeHouseInputs[i];
      element.checked = true;
    }
  }

  hideHouseType() {
    if (!this.ObjectTypeHouseInputs.length) {
      return;
    }
    this.ObjectTypeHouseType.classList.add('hidden');
    for (let i = 0; i < this.ObjectTypeHouseInputs.length; i++) {
      const element = this.ObjectTypeHouseInputs[i];
      element.checked = false;
    }
  }

  showAppartmentType() {
    if (!this.ObjectTypeAppartmentInputs.length) {
      return;
    }
    this.ObjectTypeAppartmentType.classList.remove('hidden');
    for (let i = 0; i < this.ObjectTypeAppartmentInputs.length; i++) {
      const element = this.ObjectTypeAppartmentInputs[i];
      element.checked = true;
    }
  }

  hideAppartmentType() {
    if (!this.ObjectTypeAppartmentInputs.length) {
      return;
    }
    this.ObjectTypeAppartmentType.classList.add('hidden');
    for (let i = 0; i < this.ObjectTypeAppartmentInputs.length; i++) {
      const element = this.ObjectTypeAppartmentInputs[i];
      element.checked = false;
    }
  }

  showSurfaceField() {
    if (!this.SurfaceField) {
      return;
    }
    this.SurfaceField.classList.remove('hidden');
  }

  hideSurfaceField() {
    if (!this.SurfaceField) {
      return;
    }
    this.SurfaceField.classList.add('hidden');

    if (this.SurfaceSelect) {
      this.SurfaceSelect.value = '';
    }
  }
}
